import React,{useMemo} from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceDetailsContent from './ServiceDetailsContent';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/2.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';

const MarketEntry = () => {
    const content = useMemo(() => {
        return <SectionTitle
            sectionClass="sec-title4"
            descClass="desc desc-big"
            description="Feasibility studies, regulatory guidance, and local partner sourcing to support successful market entry and expansion."
        />
    }, [])
    return (
        <React.Fragment>
            <DetailsHeader
                parentMenu='service'
                secondParentMenu='services'
                activeMenu='/market-entry'
            />
            <SiteBreadcrumb
                breadcrumbsImg={breadcrumbsImg}
                pageTitle='Market Entry & Expansion'
                pageCategory='Services'
                pageName='Market Entry'
                parentPath="/service"
            />
            <ServiceDetailsContent title="Market Entry & Expansion" subtitle="Market Entry" children={content} serviceImg={serviceImg}/>
            <Footer footerClass="rs-footer" />
            <SearchModal />
        </React.Fragment>
    );
}

export default MarketEntry;
